import { FileUp } from 'lucide-react';
import { Button } from '../../design-system/button/button';
import { Stack } from '../../design-system/stack/stack';
import { cn } from '../../utils/cn';
import { GetFileDropZoneViewProps } from './file-drop-zone';

const ICON_STROKE_WIDTH = 0.5;

export const FileDropZoneView = ({
  isLoading,
  fileRejection,
  open,
  setFileRejection,
  variant,
  fileDescription,
  supportedFileTypes = [],
}: GetFileDropZoneViewProps) => {
  return (
    <>
      <div className="h-12 w-12">
        <FileUp
          strokeWidth={ICON_STROKE_WIDTH}
          className={cn('h-full w-full font-light text-black', { 'text-black/40': isLoading })}
        />
      </div>

      <Stack className={cn({ 'flex-1': variant === 'INLINE' }, { 'align-center': variant === 'STACKED' })}>
        <p className={cn('text-sm font-normal text-black', { 'text-black/40': isLoading })}>
          Drop <strong className="font-bold">{fileDescription}</strong> here or click to upload
        </p>

        {!isLoading && supportedFileTypes.length > 0 && (
          <p className="text-seapoint-gray-text text-xs font-normal">
            Supported format: {supportedFileTypes.join(', ')}
          </p>
        )}

        {fileRejection && <p className="text-seapoint-red text-xs font-medium">{fileRejection}</p>}
      </Stack>

      <Button
        size="default"
        onClick={() => {
          setFileRejection(null);

          open();
        }}
        isLoading={isLoading}
      >
        Browse
      </Button>
    </>
  );
};
